import { useRef } from 'react';
import { StoryFrame, StoryZone } from '../../StoryViewer.styles';
import StoryViewerProgress from './StoryViewerProgress';
import StoryViewerHeader from './StoryViewerHeader';
import StoryViewerMedia from './StoryViewerMedia';
import StoryViewerReply from './StoryViewerReply';
import { getMediaDirectSrc } from '../../utils/getMediaFileId';
import { inferStoryMediaType } from '../../utils/inferStoryMediaType';

const StoryViewerFrame = ({
	currentItem,
	person,
	segmentCount,
	currentSegment,
	segmentProgress,
	isPaused,
	pauseProgress,
	resumeProgress,
	storyPausedRef,
	slideKey,
	canPlay,
	onMediaReady,
	onVideoProgress,
	onVideoEnded,
	timeAgoLabel,
	playLabel,
	pauseLabel,
	onPrev,
	onNext,
	prevLabel,
	nextLabel,
	onReply,
	replyPlaceholder,
	replySubmitLabel,
	onClose,
	closeLabel,
	interactive = true,
}) => {
	const videoRef = useRef(null);
	const mediaPosition = currentItem.position || '50% 50%';
	const mediaScale = currentItem.scale || 1;
	const posterSrc =
		getMediaDirectSrc(person?.profile_image) || person?.image || null;
	const isVideoSlide =
		currentItem.type === 'video' ||
		inferStoryMediaType(currentItem.media, person) === 'video';

	const handlePlayToggle = (e) => {
		e.stopPropagation();
		if (storyPausedRef.current) {
			resumeProgress();
			if (isVideoSlide && videoRef.current) {
				videoRef.current.play().catch(() => {});
			}
			return;
		}
		pauseProgress();
		if (videoRef.current) {
			videoRef.current.pause();
		}
	};

	return (
		<StoryFrame>
			<StoryViewerProgress
				segmentCount={segmentCount}
				currentSegment={currentSegment}
				segmentProgress={segmentProgress}
			/>
			<StoryViewerHeader
				person={person}
				timeAgoLabel={timeAgoLabel}
				isPaused={isPaused}
				onPlayToggle={handlePlayToggle}
				playLabel={playLabel}
				pauseLabel={pauseLabel}
				onClose={interactive ? onClose : undefined}
				closeLabel={closeLabel}
			/>
			{interactive && (
				<StoryZone
					$side="prev"
					type="button"
					onClick={onPrev}
					aria-label={prevLabel}
				/>
			)}
			{interactive && (
				<StoryZone
					$side="next"
					type="button"
					onClick={onNext}
					aria-label={nextLabel}
				/>
			)}
			<StoryViewerMedia
				key={`${currentItem.mediaId}-${currentItem.storyNumber}`}
				slideKey={slideKey}
				type={currentItem.type}
				media={currentItem.media}
				person={person}
				mediaId={currentItem.mediaId}
				position={mediaPosition}
				scale={mediaScale}
				poster={posterSrc}
				videoRef={videoRef}
				storyPausedRef={storyPausedRef}
				canPlay={canPlay}
				onMediaReady={onMediaReady}
				onVideoProgress={onVideoProgress}
				onVideoEnded={onVideoEnded}
			/>
			<StoryViewerReply
				placeholder={replyPlaceholder}
				submitLabel={replySubmitLabel}
				onSubmit={onReply}
			/>
		</StoryFrame>
	);
};

export default StoryViewerFrame;
